'use client';

import React, { createContext, useContext, useMemo, useState } from 'react';

export type HoveredListing = {
  id: string;
  buildingLat?: number | null;
  buildingLon?: number | null;
} | null;

export interface ListingsContextValue {
  customMap: boolean;
  setCustomMap: (next: boolean) => void;
  hasSelectedListings: boolean;
  setHasSelectedListings: (next: boolean) => void;
  hoveredListing: HoveredListing;
  setHoveredListing: (next: HoveredListing) => void;
}

const ListingsContext = createContext<ListingsContextValue>({
  customMap: false,
  setCustomMap: () => {},
  hasSelectedListings: false,
  setHasSelectedListings: () => {},
  hoveredListing: null,
  setHoveredListing: () => {},
});

export function ListingsProvider({ children }: { children: React.ReactNode }) {
  const [customMap, setCustomMap] = useState(false);
  const [hasSelectedListings, setHasSelectedListings] = useState(false);
  const [hoveredListing, setHoveredListing] = useState<HoveredListing>(null);

  const value = useMemo<ListingsContextValue>(
    () => ({
      customMap,
      setCustomMap,
      hasSelectedListings,
      setHasSelectedListings,
      hoveredListing,
      setHoveredListing,
    }),
    [customMap, hasSelectedListings, hoveredListing],
  );

  return <ListingsContext.Provider value={value}>{children}</ListingsContext.Provider>;
}

export function useListingsContext(): ListingsContextValue {
  const ctx = useContext(ListingsContext);
  return ctx;
}
